import { Footer } from '@/components/Footer';
import {
  EmpoweringPlayers,
  Friends,
  Introduction,
  News,
  NextGenApps,
  Posibilities,
  Roadmap,
  ScrollDown,
} from '@/modules/landing';
import { NextGenGaming } from '@/modules/token-sale/components/NextGenGaming/NextGenGaming';
import { LearnMore } from '@/modules/about';
import { Future, Onboarding } from '@/modules/token-sale';
import Head from 'next/head';

export default function LandingPage() {
  return (
    <div className="landing-page page-spacer">
      <Head>
        {/* <title>{t('landing:pageTitle')}</title>
        <meta name="description" content={t('landing:pageDesc') as string} />
        <meta name="og:description" content={t('landing:pageDesc') as string} />
        <meta name="og:title" content={t('landing:pageTitle') as string} />
        <meta
          name="og:image"
          content={`${window.location.origin}/images/logo_full.svg`}
        /> */}
      </Head>

      <Introduction />
      <Onboarding />
      <EmpoweringPlayers />
      <Posibilities />
      <NextGenApps />
      <NextGenGaming />

      {/* <TokenizedEsports /> */}
      <Roadmap />
      <News />
      <Friends />
      <LearnMore />
      <Footer />

      <ScrollDown />
    </div>
  );
}
